import {
  getCommentsByTenderId as getCommentsByTenderIdServer,
  createComment as createCommentServer,
  editComment as editCommentServer,
  deleteComment as deleteCommentServer,
} from '@/actions/comments';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';

export const getCommentsByTenderId = async (tenderId: string, page: number, size: number) => {
  const userAccessToken = await getUserAccessToken();
  return getCommentsByTenderIdServer(userAccessToken, tenderId, page, size);
};

export const createComment = async (tenderId: string, message: string) => {
  const userAccessToken = await getUserAccessToken();
  return createCommentServer(userAccessToken, tenderId, message);
};

export const editComment = async (commentId: string, message: string) => {
  const userAccessToken = await getUserAccessToken();
  return editCommentServer(userAccessToken, commentId, message);
};

export const deleteComment = async (commentId: string) => {
  const userAccessToken = await getUserAccessToken();
  return deleteCommentServer(userAccessToken, commentId);
};
